import React from 'react';
import { CTAButton } from './CTAButton';
import { CheckIcon, StarIcon } from 'lucide-react';
export function PricingSummary() {
  return <section id="compra" className="bg-[#060e1a] py-16 md:py-24 px-4 text-white relative overflow-hidden" data-id="element-111">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-blue-600/10 rounded-full blur-[150px] pointer-events-none" data-id="element-112"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-113">
        <h2 className="text-3xl md:text-5xl font-black text-center text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 to-yellow-500 mb-12 uppercase drop-shadow-sm" data-id="element-114">
          EN RESUMEN, ESTO ES TODO LO QUE RECIBÍS HOY
        </h2>

        <div className="relative group" data-id="element-115">
          {/* Animated border glow */}
          <div className="absolute -inset-1 bg-gradient-to-r from-blue-600 via-blue-400 to-blue-600 rounded-3xl blur opacity-30 group-hover:opacity-60 transition duration-1000 group-hover:duration-200 animate-pulse" data-id="element-116"></div>

          <div className="bg-[#0d1b2a] rounded-2xl p-6 md:p-10 border border-blue-500/30 relative shadow-2xl" data-id="element-117">
            {/* Mejor Oferta Badge */}
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-gradient-to-r from-yellow-500 to-yellow-400 text-black font-black px-6 py-2 rounded-full text-sm md:text-base uppercase tracking-widest shadow-[0_0_20px_rgba(234,179,8,0.4)] flex items-center gap-2 border-2 border-[#0d1b2a]" data-id="element-118">
              <StarIcon className="w-4 h-4 fill-black" data-id="element-119" />
              MEJOR OFERTA
              <StarIcon className="w-4 h-4 fill-black" data-id="element-120" />
            </div>

            <div className="mt-4" data-id="element-121">
              <p className="text-xl font-bold text-white mb-6 uppercase border-b border-blue-900/40 pb-4 flex items-center gap-3" data-id="element-122">
                <span className="bg-blue-600/20 text-blue-400 p-1.5 rounded-lg" data-id="element-123">
                  <CheckIcon className="w-5 h-5" data-id="element-124" />
                </span>
                Programa principal completo con 5 tomos:
              </p>

              <ul className="space-y-4 mb-8 pl-2 md:pl-4" data-id="element-125">
                {[{
                num: 'Tomo 1:',
                text: 'Fundamentos de la Videovigilancia'
              }, {
                num: 'Tomo 2:',
                text: 'Instalación Física de Cámaras Paso a Paso'
              }, {
                num: 'Tomo 3:',
                text: 'Configuración del Sistema y Acceso Remoto'
              }, {
                num: 'Tomo 4:',
                text: 'Diagnóstico de Fallas y Mantenimiento del Sistema'
              }, {
                num: 'Tomo 5:',
                text: 'Cómo Ganar Dinero Instalando Cámaras de Seguridad'
              }].map((item, i) => <li key={i} className="flex items-start" data-id="element-126">
                    <CheckIcon className="w-5 h-5 text-green-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-127" />
                    <span className="text-lg text-gray-300" data-id="element-128">
                      <strong className="text-white" data-id="element-129">{item.num}</strong>{' '}
                      {item.text}
                    </span>
                  </li>)}
              </ul>

              <p className="text-xl font-bold text-yellow-400 mb-6 uppercase border-b border-blue-900/40 pb-4 flex items-center gap-3" data-id="element-130">
                <span className="bg-yellow-500/10 text-yellow-400 p-1.5 rounded-lg" data-id="element-131">
                  <CheckIcon className="w-5 h-5" data-id="element-132" />
                </span>
                Más 3 bonos especiales:
              </p>

              <ul className="space-y-4 mb-10 pl-2 md:pl-4" data-id="element-133">
                {[{
                num: 'Bono 1:',
                text: 'Kit Profesional para Empezar en Instalación de Cámaras'
              }, {
                num: 'Bono 2:',
                text: 'Instalaciones Reales Explicadas Paso a Paso'
              }, {
                num: 'Bono 3:',
                text: 'Cómo Conseguir Tus Primeros Clientes de Instalación'
              }].map((item, i) => <li key={i} className="flex items-start" data-id="element-134">
                    <CheckIcon className="w-5 h-5 text-yellow-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-135" />
                    <span className="text-lg text-gray-300" data-id="element-136">
                      <strong className="text-white" data-id="element-137">{item.num}</strong>{' '}
                      {item.text}
                    </span>
                  </li>)}
              </ul>

              <div className="text-center bg-gradient-to-b from-[#0a1628] to-[#060e1a] p-8 md:p-10 rounded-2xl border border-blue-500/20 mb-8 relative overflow-hidden shadow-inner" data-id="element-138">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-blue-500 to-transparent" data-id="element-139"></div>

                <p className="text-xl text-gray-400 mb-3 uppercase tracking-widest font-medium" data-id="element-140">
                  Todo esto por solo:
                </p>

                <div className="flex flex-col items-center justify-center mb-2" data-id="element-141">
                  <div className="flex items-center gap-3 mb-1" data-id="element-142">
                    <span className="text-sm text-gray-500 uppercase font-bold" data-id="element-143">
                      Precio Normal:
                    </span>
                    <span className="text-2xl md:text-3xl text-gray-500 line-through decoration-red-500/50 font-bold" data-id="element-144">
                      $49.990
                    </span>
                  </div>

                  <div className="relative inline-block" data-id="element-145">
                    <p className="text-6xl md:text-8xl font-black text-transparent bg-clip-text bg-gradient-to-b from-green-400 to-green-600 drop-shadow-lg" data-id="element-146">
                      $29.990
                    </p>
                  </div>
                </div>
              </div>

              <div className="text-center" data-id="element-147">
                <CTAButton className="w-full text-xl md:text-2xl py-6 shadow-[0_0_30px_rgba(234,179,8,0.3)]" data-id="element-148">
                  [QUIERO ENTRAR AHORA]
                </CTAButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}